import useSWR from 'swr'
import { useLidoSDK } from './useLidoSDK'

export const useStakeLimitInfo = () => {
  const { stake } = useLidoSDK()

  const { data } = useSWR(
    stake ? ['get-lido-stake-limit-info'] : null,
    async () => {
      const contract = await stake.getContractStETH()
      const [
        isStakingPaused,
        isStakingLimitSet,
        currentStakeLimit,
        // @ts-ignore
      ] = await contract.read.getStakeLimitFullInfo()
      return {
        isStakingPaused,
        isStakingLimitSet,
        currentStakeLimit,
      }
    },
    {
      refreshInterval: 60000,
    },
  )

  return data
}
